import { QBS_DETAILS_DATA_TEST_ID } from '@e2e/constants/exam-management';
import { Button, DialogActions, DialogContent, Text } from '@shared/components';

interface PublishConfirmationSectionProps {
  loading?: boolean;
  draft: boolean;
  onSubmit: () => void;
  onClose: () => void;
}

export default function PublishConfirmationSection(
  props: Readonly<PublishConfirmationSectionProps>,
) {
  const { loading: isLoading, draft: isDraft, onClose, onSubmit } = props;

  const buttonLabel = isDraft ? 'Publish' : 'อัปเดตโครงสร้าง';

  return (
    <>
      <DialogContent>
        <Text>
          เมื่อทำการ Publish แล้ว
          <br />
          <Text variant='body1Semibold' component='span'>
            จะไม่สามารถแก้ไขการตั้งค่าระดับโครงสร้างได้อีก
          </Text>
          <br />
          <br />
          กรุณาตรวจสอบความถูกต้องให้เรียบร้อยก่อนดำเนินการต่อ
        </Text>
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          onClick={onClose}
          color='secondary'
          disabled={isLoading}
          size='large'
        >
          Cancel
        </Button>
        <Button
          data-testid={QBS_DETAILS_DATA_TEST_ID.PUBLISH_CONFIRMATION_MODAL_CONFIRM_BUTTON}
          onClick={onSubmit}
          loading={isLoading}
          size='large'
        >
          {buttonLabel}
        </Button>
      </DialogActions>
    </>
  );
}
